export const UPDATE_REDIRECT_AFTER_AUTH_PATH =
  'UPDATE_REDIRECT_AFTER_AUTH_PATH' as const

export const updateRedirectAfterAuthPath = (path: string | null) => ({
  type: UPDATE_REDIRECT_AFTER_AUTH_PATH,
  path,
})
